import { generateBasicAuthHeader } from "./BasicAuthHashing";
import { AUTHORIZATION } from "../constants/Constant";
import DebugLog from "../utils/DebugLog";
import { axiosAttachmentDownloadInstance, axiosDownloadReportInstance, axiosInstance, axiosMulitpartInstance } from "./AxiosIntercepter";

// get Basic auth
export const getBasicAuth = (includeAuthorizationHeader) => {
  let headers = {};
  if (includeAuthorizationHeader) {
    const headerTokken = generateBasicAuthHeader();
    const authToken = "BASIC " + headerTokken;
    //const authToken = "BASIC " + "eW1jYXVzZXI6MnhKeHp3RUdzaDNTNFF2RUMvZWRwZz09";
    DebugLog("authToken====" + authToken);
    headers[AUTHORIZATION] = authToken;
  }
  return axiosInstance.get(process.env.REACT_APP_BASIC_AUTH_API_URL, {
    headers,
  });
};

// get user login details
export const getUserLoginDetails = (reqestParams) => {
  return axiosInstance.post(process.env.REACT_APP_LOGIN_API_URL, reqestParams);
};

// create dummy user
export const createUser = (reqestParams) => {
  return axiosInstance.post("/users", reqestParams);
};

// dashboard get count header
export const getCountHeader = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_COUNT_HEADER_API_URL,
    reqestParams
  );
}

// get payout header summary
export const getPayoutTotalHeaderSummary = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_PAYOUT_TOTAL_HEADER_SUMMARY_API_URL,
    reqestParams
  );
}


// get payout header summary
export const getExclusionTotalHeaderSummaryForTransactionType = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_EXCLUSION_SUM_TRANSACTION_TYPE_LIST_API_URL,
    reqestParams
  );
}

// get payout dealer header summary
export const getPayoutDealerHeaderSummary = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_PAYOUT_DEALER_HEADER_SUMMARY_API_URL,
    reqestParams
  );
}



// get payout summary transaction type
export const getExclusionTransactionTypeRequest = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_EXCLUSION_TRANSACTION_TYPE_LIST_API_URL,
    reqestParams
  );
}

// get payout summary transaction type
export const getPayoutSummaryTransactionType = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_PAYOUT_SUMMARY_TRANSACTION_TYPE_API_URL,
    reqestParams
  );
}

// get payout activity details
export const getPayoutActivityDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_PAYOUT_ACTIVITY_DETAILS_API_URL,
    reqestParams
  );
}

// get payout summary dealer breakdown
export const getPayoutSummaryDealer = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_PAYOUT_SUMMARY_DEALER_API_URL,
    reqestParams
  );
}

// get payout details
export const getPayoutDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_PAYOUT_DETAILS_API_URL,
    reqestParams
  );
};
// get payout all transaction details
export const getPayoutAllTransactions = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_ALL_PAYOUT_TRANSACTION_LIST_API_URL,
    reqestParams
  );
};

// get payout attachment details
export const getAttachmentInfo = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_VIEW_ATTACHMENT_API_URL,
    reqestParams
  );
};


// get payout error details
export const getPayoutErrorDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_PAYOUT_ERROR_DETAILS_API_URL,
    reqestParams
  );
};

// get payout/getAllPayoutList
export const getAllPayoutList = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_ALL_PAYOUT_LIST_API_URL,
    reqestParams
  );
};

// get payout summary
export const getPayoutSummary = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_PAYOUT_SUMMARY_API_URL,
    reqestParams
  );
};

// hold payout by transaction type in first layer
export const holdPayoutTransactionType = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_HOLD_PAYOUT_TRANSACTION_TYPE_API_URL,
    reqestParams
  );
};

// hold payout by company in second layer
export const holdPayoutCompany = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_HOLD_PAYOUT_COMPANY_API_URL,
    reqestParams
  );
};


// hold payout by transactions in final layer
export const holdPayoutTransaction = (reqestParams) => {
  // if (getFromLocalStorage(USER_ROLE) === "Biz Ops") {
    return axiosInstance.post(
      process.env.REACT_APP_HOLD_PAYOUT_TRANSACTIONS_API_URL,
      reqestParams
    );
  // } else {
  //   return axiosInstance.post(
  //     process.env.REACT_APP_HOLD_PAYOUT_COMPANY_API_URL,
  //     reqestParams
  //   );
  // }
};

//  payout request approval
export const payoutRequestApproval = (reqestParams) => {
  // if (getFromLocalStorage(USER_ROLE) === "Biz Ops") {
    return axiosInstance.post(
      process.env.REACT_APP_HOLD_PAYOUT_REQUEST_APPROVAL_API_URL,
      reqestParams
    );
  // } else {
  //   return axiosInstance.post(
  //     process.env.REACT_APP_HOLD_PAYOUT_COMPANY_APPROVE_API_URL,
  //     reqestParams
  //   );
  // }
};

//  payout request approval
export const payoutApproval = (reqestParams) => {
  //if(getFromLocalStorage(USER_ROLE)==='Biz Ops'){
  return axiosInstance.post(
    process.env.REACT_APP_HOLD_PAYOUT_APPROVE_API_URL,
    reqestParams
  );
  // }else {
  //   return axiosInstance.post(process.env.REACT_APP_HOLD_PAYOUT_COMPANY_REQUEST_APPROVAL_API_URL, reqestParams);
  // }
};

// on hold header summary
export const getOnHoldHeaderSummary = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_ON_HOLD_HEADER_SUMMARY_API_URL,
    reqestParams
  );
};

// on hold activity details
export const getOnHoldActivityDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_ON_HOLD_HEADER_SUMMARY_API_URL,
    reqestParams
  );
};

// on hold summary transaction type
export const getOnHoldPayoutSummaryTransType = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_ON_HOLD_PAYOUT_SUMMARY_TRANS_TYPE_API_URL,
    reqestParams
  );
};


// get exclusion dealer list
export const getExclusionDealerList = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_EXCLUSION_DEALER_TYPE_LIST_API_URL,
    reqestParams
  );
};


// get exclusion transaction list
export const getExclusionTransactionList = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_EXCLUSION_TRANSACTION_LIST_API_URL,
    reqestParams
  );
};


// get exclusion transaction summary 
export const getExclusionTransactionSummary  = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_EXCLUSION_TRANSACTION_SUMMARY_API_URL,
    reqestParams
  );
};



// on dealer summary
export const getExclusionDealerSummary = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_EXCLUSION_DEALER_SUMMARY_API_URL,
    reqestParams
  );
};


// on hold summary transaction type
export const getOnHoldPayoutSummaryDealer = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_ON_HOLD_PAYOUT_SUMMARY_DEALER_API_URL,
    reqestParams
  );
};

// on hold payout transactions
export const getOnHoldPayoutTransactions = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_ON_HOLD_PAYOUT_TRANSACTIONS_API_URL,
    reqestParams
  );
};

// get on-hold summary
export const getOnHoldDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_ON_HOLD_DETAILS_API_URL,
    reqestParams
  );
};

// get on-hold details
export const getOnHoldSummary = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_DASHBOARD_ON_HOLD_API_URL,
    reqestParams
  );
};

// get earMarks details
export const getEarMarkDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_EARMAKR_DETAILS_API_URL,
    reqestParams
  );
};

// download earmark reports
export const earmarkReportDownload = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_EARMARK_REPORT_DOWNLOAD_API_URL,
    reqestParams
  );
};

// get earmark filter details
export const getEarMarkFilterDetailsAPI = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_EARMARK_FILTER_DETAILS_API_URL,
    reqestParams
  );
}


// get earmark filter details
export const getExclusionFilterDetailsAPI = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_EARMARK_FILTER_DETAILS_API_URL,
    reqestParams
  );
}

// get all accounts earmark details
export const getAllAccountsEarMarkDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_ALL_ACCOUNTS_EARMARK_DETAILS_API_URL,
    reqestParams
  );
}



// get all accounts earmark details
export const getAllAccountsExclusionDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_DEALER_LIST_API_URL,
    reqestParams
  );
}



// add new earmark
export const addEarmarkDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_ADD_EARMARK_DETAILS_API_URL,
    reqestParams
  );
}

// update earMarks details
export const updateEarMarkDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_UPDATE_EARMAKR_DETAILS_API_URL,
    reqestParams
  );
};

// update freeze account details
export const updateFreezeAccountDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_UPDATE_FREEZE_ACCOUNT_DETAILS_API_URL,
    reqestParams
  );
};



// add freeze account 
export const addFreezeAccount = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_ADD_FREEZE_ACCOUNT_DETAILS_API_URL,
    reqestParams
  );
};




// update freeze account details
export const unFreezeAccountDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_UPDATE_FREEZE_ACCOUNT_DETAILS_API_URL,
    reqestParams
  );
};



// update earMarks details
export const deleteEarMarkDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_DELETE_EARMAKR_DETAILS_API_URL,
    reqestParams
  );
};


// get earMarks timeline details
export const getEarMarkTimelineDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_EARMAKR_TIMELINE_DETAILS_API_URL,
    reqestParams
  );
};


// get earMarks activity details
export const getEarmarkActivityDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_EARMAKR_ACTIVITY_DETAILS_API_URL,
    reqestParams
  );
};

// get earMarks  details summary top bar
export const getEarmarkDetailsSummaryTopBarItems = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_EARMAKR_DETAILS_SUMMARY_API_URL,
    reqestParams
  );
};


// get credit debit details
export const getCreditDebitDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_DEBIT_CREDIT_API_URL,
    reqestParams
  );
};




// get adjustment description  details
export const getAdjustmentDescriptionDropdownDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_CREDIT_DEBIT_ADJUSTMENT_DESCRIPTION_DROPDOWN_API_URL,
    reqestParams
  );
};

//Add adjustment to exclusion
export const addAdjustmentToExclusion = (reqestParams,type) => {
  if(type===0){
    return axiosInstance.post(
      process.env.REACT_APP_ADD_ADJUSTMENT_TO_EXCLUSION_API_URL,
      reqestParams
    );
  }
  // }else if(type===1){
  //   return axiosInstance.post(
  //     process.env.REACT_APP_CANCEL_DEBIT_CREDIT_API_URL,
  //     reqestParams
  //   );
  // }else if(type===2){
  //   return axiosInstance.post(
  //     process.env.REACT_APP_ADD_DEBIT_CREDIT_API_URL,
  //     reqestParams
  //   );
  // }
  
};


//update debit credit details
export const updateDebitCreditDetails = (reqestParams,type) => {
  if(type===0){
    return axiosInstance.post(
      process.env.REACT_APP_UPDATE_DEBIT_CREDIT_API_URL,
      reqestParams
    );
  }else if(type===1){
    return axiosInstance.post(
      process.env.REACT_APP_CANCEL_DEBIT_CREDIT_API_URL,
      reqestParams
    );
  }else if(type===2){
    return axiosInstance.post(
      process.env.REACT_APP_ADD_DEBIT_CREDIT_API_URL,
      reqestParams
    );
  }
  
};

//add new adjustment
export const addNewAdjustmentDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_ADD_DEBIT_CREDIT_API_URL,
    reqestParams
  );
};


//add new adjustment
export const getDateDropdownListApiData = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_PAYOUT_DATES_API_URL,
    reqestParams
  );
};


export const getPayoutCycleDatesDropdownListData = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_PAYOUT_CYCLE_DATES_DROPDOWN_API_URL, 
    reqestParams
  );
};


// get adjustment description  details
export const getAddDealerDropdownDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_CREDIT_DEBIT_SEARCH_DEALER_DROPDOWN_API_URL,
    reqestParams
  );
};

// get freeze account details
export const getFreezeAccountList = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_FREEZ_ACCOUNT_DETAILS_API_URL,
    reqestParams
  );
};



// get freeze account details
export const updateAccountDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_UPDATE_FREEZE_ACCOUNT_DETAILS_API_URL,
    reqestParams
  );
};


// get freeze account details to add new account to freeze
export const getAccountDetailsToAdd = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_FREEZE_ACCOUNT_DETAILS_TO_ADD_API_URL,
    reqestParams
  );
};

// get COMPANY DETAILS
export const getCompanyDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_SEARCH_COMPANY_DETAILS_API_URL,
    reqestParams
  );
};

// get BRANCH DETAILS
export const getBranchDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_BRANCH_DETAILS_API_URL,
    reqestParams
  );
};


// get Report type DETAILS
export const getReportDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_REPORTS_DETAILS_API_URL,
    reqestParams
  );
};



// get freeze account COUNT
export const getFreezedAccountCount = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_FREEZED_ACCOUNT_COUNT_API_URL,
    reqestParams
  );
};




// get freeze account activity audit details
export const getFreezeAccountAuditActivityDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_FREEZE_ACCOUNT_AUDIT_ACTIVITY_DETAILS_API_URL,
    reqestParams
  );
};

// get credit debit activity audit details
export const getCreditDebitAuditActivityDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_CREDIT_DEBIT_ACTIVITY_DETAILS_API_URL,
    reqestParams
  );
};


// get credit debit activity audit details
export const getExclusionAuditActivityDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_EXCLUSION_AUDIT_API_URL,
    reqestParams
  );
};



// get credit debit activity audit details
export const getPayoutDatesAuditActivityDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_PAYOUT_DATES_ACTIVITY_DETAIS_API_URL,
    reqestParams
  );
};

// get credit debit activity audit details
export const getPayoutDatesAuditActivityRowDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_PAYOUT_DATES_ACTIVITY_FOR_SINGLE_ROW_IN_DETAILS_API_URL,
    reqestParams
  );
};



// get on-hold Company
export const getOnHoldCompany = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_ON_HOLD_COMPANY_API_URL,
    reqestParams
  );
};


// cancel on-hold Company
export const cancelOnHoldCompany = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_CANCEL_ON_HOLD_COMPANY_API_URL,
    reqestParams
  );
};


// release on-hold Company
export const releaseOnHoldCompany = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_RELEASE_ON_HOLD_COMPANY_API_URL,
    reqestParams
  );
};



// request release on-hold Transaction Type
export const requestReleaseOnHoldCompany = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_REQUEST_RELEASE_ON_HOLD_COMPANY_API_URL,
    reqestParams
  );
};


// release on-hold Transaction Type
export const releaseOnHoldTransactionType = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_RELEASE_ON_HOLD_TRANSACTION_TYPE_API_URL,
    reqestParams
  );
};




// cancel on-hold Transaction Type
export const cancelOnHoldTransactionType = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_CANCEL_ON_HOLD_TRANSACTION_TYPE_API_URL,
    reqestParams
  );
};


// cancel on-hold Transaction Type
export const cancelOnHoldTransactionTypeMultipart = (reqestParams) => {
 
  return axiosMulitpartInstance.post(
    process.env.REACT_APP_CANCEL_ON_HOLD_TRANSACTION_TYPE_API_URL,
    reqestParams
  );
};


// request release on-hold Transaction Type
export const requestReleaseOnHoldTransactionType = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_REQUEST_RELEASE_ON_HOLD_TRANSACTION_TYPE_API_URL,
    reqestParams
  );
};







// release on-hold all Transaction 
export const releaseOnHoldAllTransaction = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_RELEASE_ON_HOLD_TRANSACTION_API_URL,
    reqestParams
  );
};




// cancel on-hold all Transaction 
export const cancelOnHoldAllTransaction = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_CANCEL_ON_HOLD_TRANSACTION_API_URL,
    reqestParams
  );
};


// request release on-hold all Transaction 
export const requestReleaseOnHoldAllTransaction = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_REQUEST_RELEASE_ON_HOLD_TRANSACTION_API_URL,
    reqestParams
  );
};






// get on-hold Details
export const getOnHoldPayoutCycle = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_ON_HOLD_PAYOUT_CYCLE_API_URL,
    reqestParams
  );
};

// get onHold Company Payout Transaction
export const onHoldCompanyPayoutTransaction = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_ON_HOLD_COMMPANY_PAYOUT_TRANSACTIONS_API_URL,
    reqestParams
  );
};

// get withholding details
export const getWitholdingTaxDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_WITHOLDING_TAX_DETAILS_API_URL,
    reqestParams
  );
};


// update withholding details
export const updateWitholdingTaxDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_UPDATE_PAYOUT_DATES_API_URL,
    reqestParams
  );
};



// get withholding tax details
export const getWitholdingSummaryDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_WITHOLDING_TAX_SUMMARY_API_URL,
    reqestParams
  );
};

// get Payout dates
export const getPayoutDates = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_PAYOUT_CYCLE_DATES_API_URL,
    reqestParams
  );
};

// get cash out limit header details
export const getCashOutHeaderDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_CASHOUT_LIMIT_HEADER_DETAILS_API_URL,
    reqestParams
  );
};

// get cash out limit details
export const getCashOutLimitDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_CASHOUT_LIMIT_DETAILS_API_URL,
    reqestParams
  );
};

// get cash out GLOBAL limit details
export const getCashOutGlobalLimitDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_CASHOUT_GLOBAL_LIMIT_DETAILS_API_URL,
    reqestParams
  );
};

// get cash out limits activity details
export const getCashOutLimitActivityDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_CASHOUT_ACTIVITY_DETAILS_API_URL,
    reqestParams
  );
};

// get cash out timeline details
export const getCashOutTimelineDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_CASHOUT_TIMELINE_DETAILS_API_URL,
    reqestParams
  );
};

// get cash out GLOBAL timeline details
export const getCashOutGlobalTimelineDetails = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_CASHOUT_GLOBAL_TIMELINE_DETAILS_API_URL,
    reqestParams
  );
};

// get cash out GLOBAL timeline details
export const getCashOutTierValue = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_CASHOUT_TIER_VALUE_API_URL,
    reqestParams
  );
};

// apply global setting for selected dealers
export const applyGlobalSettingForDealer = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_APPLY_GLOBAL_SETTING_FOR_DEALER,
    reqestParams
  );
};

//  set cash out limit for selected dealer
export const configureCashOutLimitForSelectedDealer = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_CONFIGURE_CASH_OUT_LIMIT_FOR_DEALER,
    reqestParams
  );
};

// set cash out GLOBAL limit 
export const configureCashOutGlobalSetting = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_CONFIGURE_CASH_OUT_GLOBAL_SETTING,
    reqestParams
  );
};

// get Exclusion Report
export const getExclusionReports = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_EXCLUSION_LIST_API_URL,
    reqestParams
  );
};
// get Exclusion Report
export const getRemovedItems = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_GET_REMOVED_ITEMS_LIST_API_URL,
    reqestParams
  );
};

// add Exclusion Report
export const addExclusionReports = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_ADD_EXCLUSION_API_URL,
    reqestParams
  );
};


// download pdf viewer data
export const downloadPdfViewerData = (reqestParams) => {
  return axiosAttachmentDownloadInstance.post(
    process.env.REACT_APP_DOWNLOAD_PDF_VIEWER_DATA_API_URL,
    reqestParams
  );
};

// remove Exclusion Report
export const removeExclusionReports = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_REMOVE_EXCLUSION_API_URL,
    reqestParams
  );
};

// remove Exclusion for Adjustment
export const removeExclusionForAdjustment = (reqestParams) => {
  return axiosInstance.post(
    process.env.REACT_APP_REMOVED_EXCLUSION_FOR_ADJUSTMENT_API_URL,
    reqestParams
  );
};



// download Report
export const downloadReportModuleFile = (reqestParams) => {
  return axiosDownloadReportInstance.post(
    process.env.REACT_APP_DOWNLOAD_REPORT_MODULE_API_URL,
    reqestParams
  );
};


// download freeze account Report
export const downloadFreezeAccountReports = (reqestParams) => {
  return axiosDownloadReportInstance.post(
    process.env.REACT_APP_DOWNLOAD_REPORT_API_URL,
    reqestParams
  );
};

// download freeze account Report
export const downloadPayoutsReports = (reqestParams) => {
  return axiosDownloadReportInstance.post(
    process.env.REACT_APP_DOWNLOAD_PAYOUT_REPORT_API_URL,
    reqestParams
  );
};


// download credit debit account Report
export const downloadCreditDebitAccounttReports = (reqestParams) => {
  return axiosDownloadReportInstance.post(
    process.env.REACT_APP_DOWNLOAD_CREDIT_DEBIT_REPORT_API_URL,
    reqestParams
  );
};
// download credit debit account Report
export const downloadOnHoldReports = (reqestParams) => {
  return axiosDownloadReportInstance.post(
    process.env.REACT_APP_DOWNLOAD_ON_HOLD_REPORT_API_URL,
    reqestParams
  );
};



// download EarMark Reports
export const downloadEarmarkReports = (reqestParams) => {
  return axiosDownloadReportInstance.post(
    process.env.REACT_APP_DOWNLOAD_EARMARK_REPORT_API_URL,
    reqestParams
  );
};


// download EarMark Reports
export const downloadWithHoldingTaxReports = (reqestParams) => {
  return axiosDownloadReportInstance.post(
    process.env.REACT_APP_DOWNLOAD_WITHHOLDING_TAX_REPORT_API_URL,
    reqestParams
  );
};

// download cash out limit Reports
export const downloadCashOutLimitReports = (reqestParams) => {
  return axiosDownloadReportInstance.post(
    process.env.REACT_APP_DOWNLOAD_CASHOUT_LIMIT_REPORT_API_URL,
    reqestParams
  );
};


